module.exports = "/images/cloud_b.png";